import { Component, Input } from '@angular/core';
import { OgPreviewService } from 'src/app/services/og-preview.service';
@Component({
  selector: 'app-og-card',
  templateUrl: './og-card.component.html',
  styleUrls: ['./og-card.component.scss']
})
export class OgCardComponent {


  @Input() platform: 'shopify' | 'nuvemshop' | 'woocommerce' = 'shopify'; // futuro uso
  @Input() shopUrl: string = ''; 

  ogTitle: string = '';
  siteName: string = '';
  ogDescription: string = '';
  ogImage: string = '';

  constructor(private ogPreviewService: OgPreviewService) { }
  isLoading = true;
  async ngOnInit() {
    if (!this.shopUrl) {
      console.error('shopUrl nǜo foi fornecida para app-og-card.');
      return;
    }
    this.shopUrl = this.normalizeUrl(this.shopUrl);
  
    if (this.platform === 'shopify' || this.platform === 'nuvemshop') {
      try {
        const observable = await this.ogPreviewService.getShopifyOgData(this.shopUrl);
        observable.subscribe({
          next: (data: any) => {
            this.ogTitle = data['og:title'] || '';
            this.siteName = data['og:site_name'] || '';
            this.ogDescription = data['og:description'] || '';
            this.ogImage = data['og:image'] || 'assets/brokenImage.png';
            this.isLoading = false;
          },
          error: (err: any) => {
            this.isLoading = false;
            console.error('Erro ao buscar OG data:', err);
          }
        });
      } catch (err) {
        this.isLoading = false;
        console.error('Erro ao preparar request OG:', err);
      }
    }
  }
  
  goToShop() {
    if (this.shopUrl) {
      window.open(this.shopUrl, '_blank');
    }
  }

  private normalizeUrl(url: string): string {
    if (!url) {
      return '';
    }
    const trimmed = url.trim();
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }
    return `https://${trimmed}`;
  }
}
